<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['data', 'labels', 'tooltip'],
  mounted() {
    this.renderBarChart();
  },
  computed: {
    chartData: function() {
      return this.data;
    }
  },
  methods: {
    renderBarChart: function() {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            label: this.tooltip,
            backgroundColor: '#448aff',
            data: this.data
          }
        ]
      })
    }
  },
  watch: {
    data: function() {
      this.renderBarChart();
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/BarChart.vue